<template>
  <v-app v-if="!isMobile">
    <NavigationBar v-model="drawer" />
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
  <v-app v-else>
    <NagivationBarMobile />
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>



<script>
import NavigationBar from "../src/components/NagivationBar.vue"
import NagivationBarMobile from "../src/components/NavigationBarMobile.vue"

export default {
  name: "App",
  components: {NavigationBar, NagivationBarMobile},
  data() {
      return {
      drawer: true,
      isMobile: true,
      };
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  methods: {
  onResize() {
      this.isMobile = window.innerWidth < 700;
  },
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
  }

</script>

<style>
html,
body {
  overflow-x: hidden;
}

.apexcharts-menu.apexcharts-menu-open {
  color: black !important;
}

.apexcharts-tooltip {
  border-radius: 5px;
  border: 1px solid grey;
  color: white;
  box-shadow: 2px 2px 6px -4px #999;
  cursor: default;
  font-size: 14px;
  left: 62px;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  top: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  white-space: nowrap;
  z-index: 12;
  transition: 0.15s ease all;
  background: rgba(0, 0, 0, 0.5);
}

@page {
    size: auto;
    size: A4;
    margin: 0mm;
    margin: 1cm 0;
}

@media only print {
   html,
   body {
      width: 100%;
      height: fit-content;
      margin: 0 auto;
      overflow: visible;
      padding: 0;
    }
}
</style>
